import Konva from "konva";
import { Group } from "konva/lib/Group";
import { Shape } from "konva/lib/Shape";
import { Rect } from "konva/lib/shapes/Rect";
import { Text } from "konva/lib/shapes/Text";
import { Observable } from "rxjs";

export class GroupChipKonva {
  private static readonly CHIP_COLOR = "#0091fe";
  private static readonly BASE_SCALE_FACTOR = 0.22;
  private static readonly GROUP_ICON_PATH = "../../assets/konva-icons/gruppe.svg";

  static init(productGroup: Konva.Group, xOffset: number): Observable<Group> {
    return new Observable((observer) => {
      const circleRadius = 12;
      const circleDiameter = circleRadius * 2;
      const parentGroup = new Group({
        scaleY: this.BASE_SCALE_FACTOR,
        scaleX: this.BASE_SCALE_FACTOR,
        x: xOffset,
        name: "groupChip",
      });

      const rect = new Rect({
        x: 0,
        y: 0,
        width: 30,
        height: 24,
        fill: this.CHIP_COLOR,
      });

      const groupIndexText = new Text({
        text: productGroup.getAttr("groupId").toString(),
        fontSize: 15,
        fill: "white",
      });

      const halfCircleLeft = new Konva.Shape({
        sceneFunc: (ctx, shape) => {
          ctx.beginPath();
          ctx.arc(0, circleRadius, circleRadius, Math.PI * 1.5, Math.PI / 2, true);
          ctx.lineTo(0, circleDiameter);
          ctx.lineTo(0, 0);
          ctx.closePath();
          ctx.fillStrokeShape(shape);
        },
        fill: this.CHIP_COLOR,
      });

      const halfCircleRight = new Konva.Shape({
        sceneFunc: (ctx, shape) => {
          ctx.beginPath();
          ctx.arc(circleRadius, circleRadius, circleRadius, Math.PI / 2, Math.PI * 1.5, true);
          ctx.lineTo(circleRadius, 0);
          ctx.lineTo(circleRadius, circleDiameter);
          ctx.closePath();
          ctx.fillStrokeShape(shape);
        },
        fill: this.CHIP_COLOR,
      });
      halfCircleLeft.getSelfRect = () => ({
        x: -circleRadius,
        y: 0,
        width: circleDiameter,
        height: circleDiameter,
      });
      halfCircleRight.getSelfRect = () => ({
        x: 0,
        y: 0,
        width: circleDiameter,
        height: circleDiameter,
      });

      const groupIcon = new Image();
      groupIcon.src = this.GROUP_ICON_PATH;
      groupIcon.onload = () => {
        const groupIconImage = new Konva.Image({
          image: groupIcon,
          height: 18,
          width: 18,
        });

        parentGroup.add(rect);
        parentGroup.add(halfCircleLeft);
        parentGroup.add(halfCircleRight);
        parentGroup.add(groupIconImage);
        parentGroup.add(groupIndexText);

        this.setChip(rect, groupIconImage, groupIndexText, halfCircleLeft, halfCircleRight);
        observer.next(parentGroup);
        observer.complete();
      };
    });
  }

  static setPosition(parentGroup: Group, xOffset: number, yOffset: number) {
    parentGroup.position({ x: xOffset, y: yOffset });
  }

  private static setChip(rect: Rect, icon: Konva.Image, groupIndexText: Text, circleLeft: Shape, circleRight: Shape) {
    const padding = 4;
    circleLeft.x(15);

    rect.x(circleLeft.x() + circleLeft.width());
    rect.width(icon.width() + groupIndexText.width() - 4);

    circleRight.x(rect.width() + 3);

    const startX = (icon.width() + groupIndexText.width() + padding - rect.width()) / 2;

    icon.x(rect.x() - startX);
    icon.y((rect.height() - icon.height()) / 2);

    groupIndexText.x(icon.x() + icon.width() + padding);
    groupIndexText.y((rect.height() - groupIndexText.height()) / 2); // Vertically center relative to icon
  }
}
